export default __webpack_public_path__ + "static/media/INEX-sm.b5d866dd.svg";